import { graphql } from '#@/__gql__';

export const trackExperimentImpressionMutation = graphql(/* GraphQL */ `
  mutation TrackExperimentImpression($experimentFlagName: EXPERIMENT_NAME!) {
    trackExperimentImpression(experimentFlagName: $experimentFlagName)
  }
`);

export const trackExperimentMetricMutation = graphql(/* GraphQL */ `
  mutation TrackExperimentMetric($metricName: String!) {
    trackExperimentMetric(metricName: $metricName)
  }
`);

export const trackBidPackageExperimentMetricMutation = graphql(/* GraphQL */ `
  mutation TrackBidPackageExperimentMetric($bidPackageId: String!, $metricName: String!) {
    trackBidPackageExperimentMetric(bidPackageId: $bidPackageId, metricName: $metricName)
  }
`);
